let interceptor = false;

export function getInterceptor() {
    return interceptor;
}

export function setInterceptor(inter) {
    interceptor = inter;
}